module.exports = __webpack_public_path__ + "static/media/instagram.4a8c2347.png";